import { SyntheticEvent } from "react";
import charityIcon from '../assets/donate.svg';
import heic2any from "heic2any";

export const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
  event.currentTarget.src = charityIcon;
};
